var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "report-filters flex-row ai-center white-bkg bl-1 bt-1 br-1 jc-space px-3 py-3 br br-bottom-0"
    },
    [
      _c(
        "div",
        [
          _c("timeline-author-filter", {
            attrs: { selected: _vm.authors },
            on: { input: _vm.selectStaff }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "report-filters-datepicker" },
        [
          _c("el-date-picker", {
            staticClass: "wp-10 py-0",
            attrs: {
              type: "daterange",
              align: "center",
              format: _vm.datePickerFormat,
              "picker-options": _vm.pickerOptions,
              "start-placeholder": _vm.$t.__("common.labels.start_date"),
              "end-placeholder": _vm.$t.__("common.labels.end_date"),
              clearable: false
            },
            on: { change: _vm.updateDates },
            model: {
              value: _vm.dates,
              callback: function($$v) {
                _vm.dates = $$v
              },
              expression: "dates"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "report-filters-mode" },
        [
          _vm.isActiveDisplayMode
            ? _c(
                "el-select",
                {
                  staticClass: "report-filters-select",
                  attrs: {
                    value: _vm.periodSelected,
                    "popper-class": "report-filters-select__popper"
                  },
                  on: { change: _vm.updatePeriod }
                },
                _vm._l(_vm.periods, function(period) {
                  return _c("el-option", {
                    key: period.id,
                    ref:
                      "reportFiltersSelectPopperOptions" +
                      (_vm.periodSelected === period.id ? "Selected" : ""),
                    refInFor: true,
                    attrs: {
                      value: period.id,
                      label: period.label,
                      disabled: _vm.isPeriodDisable(period)
                    }
                  })
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }